import { takeEvery, put, call } from "redux-saga/effects";

import { ACCESS_TEMPLATE_LIST, ADD_ACCESS_TEMPLATE, ASSIGN_ACCESS, GET_ACCESS_TEMPLATE, UPDATE_ACCESS_TEMPLATE } from "./actionTypes";

import {
  updateAccessTemplateSuccess,
  updateAccessTemplateFail,
  addAccessTemplateSuccess,
  accessTemplateListSuccess,
  accessTemplateListFail,
  assignAccessSuccess,
  assignAccessFail,
  getAccessTemplateSuccess,
  getAccessTemplateFail,
} from "./actions";

import { onUpdateRoleAcces, onAddRoleAcces, onGetRoleAcces, onAssingAccess, onGettingAccessTemplate } from "helpers/fakebackend_helper";

import { responseHandler } from "common/CommanFunction";

function* onGet({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGetRoleAcces, data);
    yield call(responseHandler, "Role Access", response, accessTemplateListSuccess, accessTemplateListFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(accessTemplateListFail(error));
    showToast("error", "Role Access", error);
  }
}

function* onUpdate({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onUpdateRoleAcces, data);
    yield call(responseHandler, "Role Access", response, updateAccessTemplateSuccess, updateAccessTemplateFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(updateAccessTemplateFail(error));
    showToast("error", "Role Access", error);
  }
}

function* onAdd({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onAddRoleAcces, data);
    yield call(responseHandler, "Role Access", response, addAccessTemplateSuccess, addAccessTemplateSuccess, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(addAccessTemplateSuccess(error));
    showToast("error", "Role Access", error);
  }
}

function* onAssign({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onAssingAccess, data);
    yield call(responseHandler, "Role Access", response, assignAccessSuccess, assignAccessFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(assignAccessFail(error));
    showToast("error", "Role Access", error);
  }
}

function* onGetByID({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingAccessTemplate, data);
    yield call(responseHandler, "Role Access", response, getAccessTemplateSuccess, getAccessTemplateFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(getAccessTemplateFail(error));
    showToast("error", "Role Access", error);
  }
}

export function* RoleAccessSaga() {
  yield takeEvery(ASSIGN_ACCESS, onAssign);
  yield takeEvery(ADD_ACCESS_TEMPLATE, onAdd);
  yield takeEvery(ACCESS_TEMPLATE_LIST, onGet);
  yield takeEvery(GET_ACCESS_TEMPLATE, onGetByID);
  yield takeEvery(UPDATE_ACCESS_TEMPLATE, onUpdate);
}

export default RoleAccessSaga;
